import { WrappedEventTask } from '../../model/WrappedEventTask'
import { http } from '../../utils/http'

export const getEventTasksAsync = async (
    partyEventId: number,
    token: string
) : Promise<WrappedEventTask[]> => {
    const result = await http<undefined, WrappedEventTask[]>({
        path: `EventTasks?partyEventId=${partyEventId}`,
        accessToken: token
    })
    if (result.ok && result.parsedBody) {
        return result.parsedBody || []
    }
    return []
}

export const deleteEventTaskAsync = async (
    eventTaskId: number,
    userEmail: string,
    token: string
) : Promise<boolean> => {
    const result = await http<undefined, undefined>({
        method: 'delete',
        path: `EventTasks?eventTaskId=${eventTaskId}&email=${userEmail}`,
        accessToken: token
    })
    if (result.ok && result.parsedBody) {
        return result.parsedBody || null
    }
    return result.ok
}